<template>
    <div class="container">
        <div class="row">
            <div class="col-12 col-md-10 offset-md-1">
                <div class="rte">
                    <slot></slot>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
export default {
    mounted() {
        this.setTitleLinks();
    },
    methods: {
        setTitleLinks() {
            const titles = document.getElementsByTagName('strong');
            const headerTitle = document.getElementsByTagName('h2')[0];

            for (let i = titles.length - 1; i >= 0; i--) {
                titles[i].id = 'header' + [i];
                titles[i].className = 'offset';

                headerTitle.insertAdjacentHTML(
                    'afterend',
                    '<a href="#header' +
                        [i] +
                        '">' +
                        titles[i].innerHTML +
                        '<br />'
                );
            }
        }
    }
};
</script>
<style lang="scss">
.offset::before {
    display: block;
    content: ' ';
    margin-top: -150px;
    height: 150px;
    visibility: hidden;
    pointer-events: none;
}
</style>
